"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpGuideGroup = exports.HelpGuideSection = exports.TServiceIssueStatus = exports.TResolutionType = exports.NodeDevicePort = exports.NodeDeviceInstallationStatus = exports.ManagementTypes = exports.ConsumableType = exports.NodeTypes = void 0;
// enums and other values
const app_platform_internal_api_sdk_1 = require("@semios/app-platform-internal-api-sdk");
Object.defineProperty(exports, "ConsumableType", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.ConsumableType; } });
Object.defineProperty(exports, "ManagementTypes", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.ManagementTypes; } });
Object.defineProperty(exports, "NodeDeviceInstallationStatus", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.NodeDeviceInstallationStatus; } });
Object.defineProperty(exports, "NodeDevicePort", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.NodeDevicePort; } });
Object.defineProperty(exports, "NodeTypes", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.NodeTypes; } });
Object.defineProperty(exports, "TResolutionType", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.TResolutionType; } });
Object.defineProperty(exports, "TServiceIssueStatus", { enumerable: true, get: function () { return app_platform_internal_api_sdk_1.TServiceIssueStatus; } });
/* eslint-enable padding-line-between-statements */
var HelpGuideSection;
(function (HelpGuideSection) {
    HelpGuideSection["QA"] = "QA";
    HelpGuideSection["ASSEMBLY"] = "ASSEMBLY";
    HelpGuideSection["INSTALLATION"] = "INSTALLATION";
    HelpGuideSection["MAINTENANCE"] = "MAINTENANCE";
})(HelpGuideSection || (exports.HelpGuideSection = HelpGuideSection = {}));
var HelpGuideGroup;
(function (HelpGuideGroup) {
    HelpGuideGroup["USER_GUIDES"] = "USER_GUIDES";
    HelpGuideGroup["DEVICE_INSTALLATION"] = "DEVICE_INSTALLATION";
    HelpGuideGroup["STATION_INSTALLATION"] = "STATION_INSTALLATION";
})(HelpGuideGroup || (exports.HelpGuideGroup = HelpGuideGroup = {}));
//# sourceMappingURL=serviceCenter.js.map